import React from 'react'
import {
    type ModelsShiftAvailableStationOutput,
    useGetApiBarberShiftsAvailableSlots,
} from '@barbershop/api/barber'

import { FORMATTED_TODAY_DATE, FORMATTED_TOMORROW_DATE } from '../../model/constants'

export type StationInfo = ModelsShiftAvailableStationOutput

export type Stations = Record<string, StationInfo[]>

export const useAvailableStationsFetch = () => {
    const { data, isLoading } = useGetApiBarberShiftsAvailableSlots({
        from: FORMATTED_TODAY_DATE,
        to: FORMATTED_TOMORROW_DATE,
    })

    const stationsByDate = React.useMemo(() => {
        const result: Stations = {}

        if (data && data.days) {
            for (const day of data.days) {
                if (!day.date || !day.stations) {
                    continue
                }

                result[day.date] = day.stations
            }
        }

        return result
    }, [data])

    return { stationsByDate, isLoading }
}
